import { render, staticRenderFns } from "./ScrollCardList.vue?vue&type=template&id=31f22a4b&scoped=true&"
import script from "./ScrollCardList.vue?vue&type=script&lang=js&"
export * from "./ScrollCardList.vue?vue&type=script&lang=js&"
import style0 from "./ScrollCardList.vue?vue&type=style&index=0&id=31f22a4b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f22a4b",
  null
  
)

export default component.exports